adminApp.directive("localSocketVersions", function(){
	return {
		templateUrl: '/public/directives/localSocketVersions.html',
		link: function($scope){
            // filtering the files according to the selected sockets
            $scope.$watch("filterType", function(newVal, oldVal){
                $scope.socketVersions = $scope.origSocketVersions;
            	if(newVal){
            		if($scope.socketVersions && newVal.platform.size ==1 ){
                        $scope.socketVersions = $scope.socketVersions.filter(function (singleVersion) {
                        	// platform is supported
                        	return singleVersion.supportedPlatforms && newVal.platform &&
									// we have one platform only since only one socket type is allowed
								singleVersion.supportedPlatforms.indexOf(newVal.platform.values().next().value) >= 0;
                        });
                    }
                }
            });

            /**
			 * will parse the version name from the given string
			 * this should support the different kinds of naming conventions
			 * of files - old and new
             * @param versionName
             * @returns {*}
             */
			$scope.parseVersionName = function (versionName) {
				var tokens = versionName.split('_');
				for(var ind in tokens){
					if(tokens[ind].match(/^\d/)){
						/*
						 * cutting the prefix of the file until the build number - then append all relevant data from
						 * the version name (remove the tar.jz ending )
						*/
						return tokens.slice(ind,tokens.length-2).join('_');
					}
				}
            };

			function init() {
                if($scope.socketVersionHideLatest){
                    $scope.socketVersion.upgradeType = "VERSION";
                }

                // Fetch socket versions
                store.fetch({
                    path: "/getSocketLocalVersions",
                    method: 'POST',
                    queryParams: {'limit':150},
                    success: function(data) {
                        // sorting the results since they are sorted by last modified
                        data = data.sort(function (a,b) {
							if(a.fileName > b.fileName)	return -1;
							if(a.fileName < b.fileName) return 1;
							return 0;
                        });
                        $scope.socketVersions = data;
                        $scope.origSocketVersions = data;
                    }
                });
            }

            init();
 		}
	}
});